import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ModalController, NavParams} from '@ionic/angular';
import {CreateUserInput} from 'src/app/API.service';
import {SessionService} from '../services/session.service';
import {Roles} from '../enums/enums';
import {DataStore} from '@aws-amplify/datastore';
import {PermissionType, Team, User} from '../../models';
import {
    ToastServiceHelperService
} from '../services/toast-service-helper.service';
import {
    FilePickerComponent
} from '../components/file-picker/file-picker.component';
import {NotificationService} from "../services/notification.service";
import {environment} from "../../environments/environment";


@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.page.html',
    styleUrls: ['./edit-user.page.scss'],
})
export class EditUserPage implements OnInit {
    @Input() isClient;
    @Input() userId;

    public currentUser: User;
    public emailError = false;
    public phoneError = false;
    public userForm: UntypedFormGroup;
    public advisors: any[];
    public teams: any;
    private teamID: string;
    public saveUserButtonText = 'Update';
    public roles = Roles;
    public selectedRole: string;
    public permissionsType = PermissionType;
    public roleNames: any[]; // No way to use Object.values in template...
    @ViewChild('imgProfilePicker') filePickerComponent: FilePickerComponent;

    constructor(
        public sessionService: SessionService,
        private toastService: ToastServiceHelperService,
        private notifficationService: NotificationService,
        public fb: UntypedFormBuilder,
        public navParams: NavParams,
        public modalController: ModalController) {
        this.userForm = this.fb.group({
            'name': [''],
            'lastname': [''],
            'cf': [''],
            'numeroCI': [''],
            'TRC20': [''],
            'email': [''],
            'phoneNumber': [''],
            'role': [''],
            'permessions': [''],
            // 'assignedTo': [''],
            // 'teamID': [''],
            'addedBy': [null],
            'notes': [''],
        });

        const roles = Object.values(this.roles);
        this.roleNames = roles.filter(r => {
            return r.displayName == this.roles.ADVISOR.displayName || r.displayName == this.roles.CLIENT.displayName;
        });
    }

    async ngOnInit() {
        if (!this.userId) this.saveUserButtonText = 'Create';
        this.currentUser = this.userId ? await DataStore.query(User, this.userId) : null;

        // this.seniorAgents = await DataStore.query(User, u => u.role("eq", Roles.SENIOR.displayName)); // we need only seniors for "assignedTo" property
        this.advisors = await DataStore.query(User, u => u.permessions('ne', PermissionType.CLIENT));

        this.teams = await DataStore.query(Team);
        if (this.currentUser) {
            const addby = this.currentUser?.addedBy;

        } else {
            const addby = this.sessionService.user.id;
        }

        this.userForm.setControl('name', new UntypedFormControl(this.currentUser?.name || '', Validators.compose([Validators.required, this.nameValidator.bind(this)])));
        this.userForm.setControl('lastname', new UntypedFormControl(this.currentUser?.lastname, Validators.compose([Validators.required, this.nameValidator.bind(this)])));
        this.userForm.setControl('email', new UntypedFormControl(this.currentUser?.email, Validators.compose([Validators.required, this.nameValidator.bind(this)])));
        this.userForm.setControl('phoneNumber', new UntypedFormControl(this.currentUser?.phoneNumber, [Validators.required, Validators.minLength(10), Validators.maxLength(15), this.phoneValidator.bind(this)]));
        this.userForm.setControl('role', new UntypedFormControl(this.currentUser?.role || (this.isClient ? Roles.CLIENT.displayName : Roles.ADVISOR.displayName), Validators.compose([Validators.required])));
        this.userForm.setControl('permessions', new UntypedFormControl(this.currentUser?.permessions || this.permissionsType.CLIENT));
        // this.userForm.setControl('assignedTo', new FormControl(this.currentUser?.assignedTo));
        // this.userForm.setControl('teamID', new FormControl(this.currentUser?.teamID));
        this.userForm.setControl('cf', new UntypedFormControl(this.currentUser?.cf));
        this.userForm.setControl('numeroCI', new UntypedFormControl(this.currentUser?.numeroCI));
        this.userForm.setControl('TRC20', new UntypedFormControl(this.currentUser?.TRC20));
        this.userForm.setControl('addedBy',
            this.currentUser ? new UntypedFormControl(this.currentUser?.addedBy) : new UntypedFormControl(this.sessionService.user.id));
        this.userForm.setControl('notes', new UntypedFormControl(this.currentUser?.notes));
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    async saveUser() {
        try {
            this.currentUser = this.currentUser ? await this.updateUser() : await this.createUser();




            this.modalController.dismiss();
        } catch (e) {


           return  this.toastService.error(e.message);

        }

    };

    async createFirstUserTeam() {
        const createTeamInput: Team = new Team({
            name: `Team ${this.userForm.value.name} ${this.userForm.value.lastname}`,
            description: '',
            manager: this.currentUser,
        });

        try {
            const savedTeam = await DataStore.save(createTeamInput);
            this.teamID = savedTeam.id;
            await DataStore.save(User.copyOf(this.currentUser, draft => {
                draft.teamID = savedTeam.id;
            }));

            await this.chengeTeam(this.currentUser.id, savedTeam.id);
        } catch (e) {


        }
    }

    async chengeTeam(userId, teamId) {
        const users = await DataStore.query(User, u => u.addedBy('eq', this.currentUser.id));
        if (users == null || users?.length == 0) {
            return;
        }
        for (const user of users) {
            await DataStore.save(User.copyOf(user, draft => {
                draft.teamID = teamId;
            }));
            await this.chengeTeam(user.id, teamId);
        }
    }

    private async updateUser() {
        const original = await DataStore.query(User, this.currentUser.id);
        const team = await DataStore.query(User, this.userForm.value.addedBy);
        const fileIdentifier: any = await this.storeFile();


        return DataStore.save(User.copyOf(original, updated => {
            updated.name = this.userForm.value?.name?.toLowerCase()?.trim(),
                updated.lastname = this.userForm.value?.lastname?.toLowerCase()?.trim(),
                updated.notes = this.userForm.value.notes,
                updated.profileImg = fileIdentifier || original.profileImg || null;
            updated.email = this.userForm.value?.email?.toLowerCase()?.trim(),
                updated.cf = this.userForm.value?.cf || "",
                updated.permessions = this.userForm.value.permessions,
                updated.numeroCI = this.userForm.value.numeroCI,
                updated.TRC20 = this.userForm.value.TRC20,
                updated.phoneNumber = this.userForm.value.phoneNumber,
                updated.role = this.userForm.value.role.displayName || this.userForm.value.role,
                updated.teamID = team?.teamID || null,
                updated.addedBy = this.userForm.value.addedBy || null;
        }));
    }

    titleCaseWord(word: string) {
        if (!word) return word;
        return word[0].toUpperCase() + word.substr(1)?.toLowerCase();
    }

    private async createUser() {
        try {


            const currentUser = this.sessionService.getCurrentUser();

            const fileIdentifier: any = await this.storeFile();
            if (this.userForm.value.addedBy == null || this.userForm.value.addedBy == '')
                this.userForm.value.addedBy = null;
            let createUserInput: CreateUserInput = {
                name: this.userForm.value.name?.toLowerCase()?.trim(),
                lastname: this.userForm.value.lastname?.toLowerCase()?.trim(),
                notes: this.userForm.value.notes,
                profileImg: fileIdentifier,
                numeroCI: this.userForm.value.numeroCI,
                TRC20: this.userForm.value.TRC20,
                cf: this.userForm.value.cf || "",
                phoneNumber: this.userForm.value.phoneNumber,
                role: this.userForm.value.role.displayName,
                permessions: this.userForm.value.permessions || PermissionType.CLIENT,
                addedBy: this.userForm.value.addedBy,
                email: this.userForm.value.email?.toLowerCase()?.trimEnd(),
            };
            if (this.userForm.value.addedBy) {
                createUserInput['addedBy'] = this.userForm.value.addedBy;
                // assign to same team
                const addedByModel = await DataStore.query(User, this.userForm.value.addedBy);
                createUserInput['teamID'] = addedByModel.teamID;
            }
            const u = await DataStore.save(new User(createUserInput));
            await this.notifficationService.notifyAdmin(environment.notificatiosn.amministratore.nuovo_cliente, 'profile/' + u.id)

            return u;
        } catch (e) {
           throw e;
        }
    }

    private async storeFile() {
        try {
            // const fileToUpload = await fetch(this.uploadedFile);
            // const fileBlob = await fileToUpload.blob();
            // const result = await Storage.put('public/x/' + this.uploadedFile.name, this.uploadedFile);
            // const result = await Storage.put(this.uploadedFile.name, fileBlob, {
            //   // contentType: 'image/png' // contentType is optional
            // });
            if (this.filePickerComponent.isToUpload)
                return await this.filePickerComponent.uploadFile();
            else
                return null;
        } catch (err) {

        }
    }

    roleSelected($event) {
        this.selectedRole = $event.detail.value;
        this.resetFieldsForRole();
    }

    private resetFieldsForRole() {
        // if ([this.roles.ADMIN.toString(), this.roles.ADVISOR.toString(), this.roles.SENIOR.toString()].includes(this.selectedRole)) {
        //     this.userForm.controls["assignedTo"].setValue(null);
        // } else if ([this.roles.JUNIOR.toString(), this.roles.CLIENT.toString()].includes(this.selectedRole)) {
        //     this.userForm.controls["teamID"].setValue(null);
        // }
    }


    // @todo Validation

    isValid(field: string) {
        let formField = this.userForm.get(field);
        return formField.valid || formField.pristine;
    }

    nameValidator(control: UntypedFormControl): { [s: string]: boolean } {
        if (!!control.value) {
            if (!control.value.match('^[a-zA-Z ,.\'-]+$')) {
                return {invalidName: true};
            }
        } else {
            // this.username1 = false;
        }
    }

    phoneValidator(control: UntypedFormControl): { [s: string]: boolean } {
        if (!!control.value && !(control.value.match('[0-9]+'))) {
            return {invalidPhone: true};
        } else {
            this.phoneError = false;
        }
    }
}
